type MarketingRedirect = {
  source: string;
  medium: string;
  campaign: string;
  content: string;
};

const xRedirect: MarketingRedirect = {
  source: "x",
  medium: "social",
  campaign: "launch",
  content: "bio",
};
const youtubeRedirect: MarketingRedirect = {
  source: "youtube",
  medium: "social",
  campaign: "launch",
  content: "channel",
};
const telegramRedirect: MarketingRedirect = {
  source: "telegram",
  medium: "social",
  campaign: "launch",
  content: "channel",
};
const instagramRedirect: MarketingRedirect = {
  source: "instagram",
  medium: "social",
  campaign: "launch",
  content: "bio",
};
const threadsRedirect: MarketingRedirect = {
  source: "threads",
  medium: "social",
  campaign: "launch",
  content: "bio",
};
const coinmarketcapRedirect: MarketingRedirect = {
  source: "coinmarketcap",
  medium: "listing",
  campaign: "launch",
  content: "profile",
};

const REDIRECTS: Record<string, MarketingRedirect> = {
  x: xRedirect,
  youtube: youtubeRedirect,
  yt: youtubeRedirect,
  telegram: telegramRedirect,
  tg: telegramRedirect,
  instagram: instagramRedirect,
  ig: instagramRedirect,
  threads: threadsRedirect,
  th: threadsRedirect,
  coinmarketcap: coinmarketcapRedirect,
  cmc: coinmarketcapRedirect,
};

export const MARKETING_LINKS = Object.freeze({
  x: "/go/x",
  youtube: "/go/yt",
  telegram: "/go/tg",
  instagram: "/go/ig",
  threads: "/go/th",
  coinmarketcap: "/go/cmc",
});

function redirectCodeFromPath(pathname: string) {
  const match = pathname.match(/^\/go\/([^/?#]+)\/?$/i);
  return match?.[1]?.toLowerCase();
}

export function getMarketingRedirectTarget(pathname: string) {
  const code = redirectCodeFromPath(pathname);
  if (!code) return null;

  const redirect = REDIRECTS[code];
  if (!redirect) return null;

  const params = new URLSearchParams({
    utm_source: redirect.source,
    utm_medium: redirect.medium,
    utm_campaign: redirect.campaign,
    utm_content: redirect.content,
  });

  return `/?${params.toString()}`;
}

export function applyMarketingRedirect() {
  if (typeof window === "undefined") return false;

  const target = getMarketingRedirectTarget(window.location.pathname);
  if (!target) return false;

  window.history.replaceState(window.history.state, "", target);
  return true;
}
